import gatorBackupBR from './gatorBackup.br';
import gatorBackupMX from './gatorBackup.mx';
import gatorBackupCL from './gatorBackup.cl';
import gatorBackupCO from './gatorBackup.co';

const gatorBackup = {
  BR: gatorBackupBR,
  MX: gatorBackupMX,
  CL: gatorBackupCL,
  CO: gatorBackupCO,
};

export default gatorBackup;
